/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_FoundInputs */

const en_issue_not_found = /** @type {(inputs: Issue_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not in this linesheet`)
};

/**
* | output |
* | --- |
* | "is not in this linesheet" |
*
* @param {Issue_Not_FoundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_found = /** @type {((inputs?: Issue_Not_FoundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_FoundInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_found(inputs)
});